<div class="wrapper">
    <div>
        <app-navbar-auth></app-navbar-auth>
        <router-outlet></router-outlet>
    </div>
</div>